<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Atendimentos odontológicos"
    >
        <rkm-table
            :fields="fields"
            :items="atendimentos"
            hide-filters
            sort-by="data"
            sort-desc
        >
            <template v-slot:cell(data)="{ item }">
                {{ item.data | formatDate }}
            </template>

            <template v-slot:cell(dataExportacao)="{ item }">

                <span v-if="item.dataExportacao">
                    {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
                </span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="edit(item.id)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
                <rkm-button
                    @click="handleDestroy(item.id)"
                    color="danger"
                    title="Excluir"
                    :disabled="item.exportacao == 1"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel"> Fechar </rkm-button>

            <rkm-button @click="create()" color="primary">
                Novo atendimento
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import { repository, error, stringCase } from '@/mixins'
import formats from '@/filters/formats'
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories = {
            atendimentoOdontologico: this.getConectaSusRepository('atencaoBasica.atendimentoOdontologico'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    data: () => ({
        repositories: null,
        atendimentos: [],
        pacienteId: null,
        enums: {
            subclassificacao
        }
    }),
    filters: {
        formatDate: formats.formatDate
    },
    computed: {
        fields() {
            return [
                {
                    key: "data",
                    label: "Data",
                },
                {
                    key: "turno",
                    label: "Turno",
                },
                {
                    key: "local",
                    label: "Local",
                },
                {
                    key: "profissional",
                    label: "Profissional",
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        }
    },
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        open(item) {
            this.pacienteId = item.id
            this.paciente = item
            this.setLoading()
            this.repositories.atendimentoOdontologico.getAtendimentos(item.id)
                .then(({ data }) => {
                    this.atendimentos = data
                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        create() {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: this.pacienteId}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')
                        return false
                    }

                    if (this.paciente.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.$router.push({ name: 'atencao-basica-atendimento-odontologico-create', params: { id: this.pacienteId } })

                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm)

                            return false
                    }

                    this.$router.push({ name: 'atencao-basica-atendimento-odontologico-create', params: { id: this.pacienteId } })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(id) {
            this.$router.push({ name: 'atencao-basica-atendimento-odontologico-edit', params: { id: id } })
        },
        handleDestroy(id) {
            const destroy = async () => {
                this.setLoading()
                this.repositories.atendimentoOdontologico.destroy(id)
                    .then(() => {
                        this.atendimentos = this.atendimentos.filter(atendimento => {
                            return atendimento.id != id
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            this.showDeleteConfirmation(
                'Deseja realmente excluir o atendimento?',
                destroy,
                this.handleError
            )
        }
    },
    mixins: [ repository, error, stringCase ],
    props: {
        model: { type: Object, required: false, },
    },
}
</script>